// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/style.bundle.css
// module id = 39Lb
// module chunks = 24